import React, { useContext } from 'react';
import { Text } from 'components/typography/Text';
import { CheckMarkIcon } from 'assets/icons/CheckMarkIcon';
import { ShouldRender } from 'components/ShouldRender';
import { AccessManagement2NModalContext } from '../../../AccessManagement2NModalContext';
import styles from './styles.module.scss';

export const Resource = ({ resource }) => {

  const { selectedResource, setSelectedResource } = useContext(AccessManagement2NModalContext);

  const onResourceClick = () => {
    setSelectedResource(resource);
  };

  return (
    <div
      className={styles.groupCard}
      onClick={onResourceClick}
    >
      <div className={styles.details}>
        {/*<div className={styles.icon}>*/}
        {/*  {resource.icon}*/}
        {/*</div>*/}
        <Text
          size={14}
          uppercase
        >
          {resource.name}
        </Text>
      </div>

      <ShouldRender condition={selectedResource && selectedResource.id === resource.id}>
        <CheckMarkIcon
          active
        />
      </ShouldRender>
    </div>
  );
};
